// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wine-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  width: 100%;
  height: 100%; /* Take full height of grid cell */
  display: flex;
  flex-direction: column;
  will-change: transform; /* Optimize for transform animations */
  contain: layout style paint; /* CSS containment for better performance */
}

.wine-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.wine-image-container {
  position: relative;
  height: auto; /* Changed from fixed height to auto */
  overflow: visible; /* Changed from hidden to visible */
}

.wine-image {
  width: 100%;
  height: auto; /* Changed from 100% to auto to maintain aspect ratio */
  object-fit: contain; /* Changed from cover to contain to show full image */
  transition: transform 0.3s ease, opacity 0.3s ease;
  display: block; /* Ensure proper image display */
}

.wine-image-clickable {
  cursor: pointer;
}

/* Disable preview on mobile devices */
@media (max-width: 768px) {
  .wine-image-clickable {
    cursor: default;
    pointer-events: none;
  }
}

.wine-card:hover .wine-image {
  transform: scale(1.05);
}

/* Image loading states */
.wine-image-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  opacity: 1;
}

.wine-image-loading {
  opacity: 0;
  position: relative;
  z-index: 2;
}

.wine-image-loaded {
  opacity: 1;
  position: relative;
  z-index: 2;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.wine-type-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  background: rgba(61, 24, 24, 0.9);
  color: white;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.wine-content {
  padding: 15px;
  flex: 1; /* Take remaining space */
  display: flex;
  flex-direction: column;
}

.wine-name {
  margin: 0 0 6px 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #3D1818;
  line-height: 1.3;
  font-family: 'Playfair Display', serif;
}

.wine-details {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.wine-region {
  background: #F7E9D2;
  color: #3D1818;
  padding: 3px 6px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 500;
}

.wine-vintage {
  background: #E8D5B7;
  color: #3D1818;
  padding: 3px 6px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 500;
}

.wine-description {
  margin: 0 0 12px 0;
  color: #5D3A3A;
  line-height: 1.6;
  font-size: 0.85rem;
  background: #FAF6E7;
  padding: 10px;
  border-radius: 8px;
  border-left: 3px solid #D4A574;
  flex: 1; /* Take remaining space to push specs to bottom */
  white-space: pre-wrap; /* Preserve newlines and whitespace */
  word-wrap: break-word; /* Break long words if needed */
}

/* Bullet points in description */
.wine-description ul {
  margin: 8px 0;
  padding-left: 20px;
  list-style-type: disc;
}

.wine-description li {
  margin: 4px 0;
}

.wine-description p {
  margin: 8px 0;
}

.wine-description p:first-child {
  margin-top: 0;
}

.wine-description p:last-child {
  margin-bottom: 0;
}

.wine-specs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  margin-top: auto; /* Push to bottom of card */
  gap: 10px;
}

.wine-specs-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.wine-alcohol {
  background: #E8D5B7;
  color: #3D1818;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.wine-temperature {
  background: #D4E8F5;
  color: #1B4F72;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.wine-price-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-end;
}

.wine-price {
  font-size: 1rem;
  font-weight: 700;
  color: #3D1818;
  font-family: 'Playfair Display', serif;
}

.wine-price-old {
  font-size: 0.8rem;
  font-weight: 600;
  color: #8B7355;
  text-decoration: line-through;
  font-family: 'Playfair Display', serif;
}

.wine-price-promo {
  color: #B22222;
}

.wine-promo-until {
  font-size: 0.7rem;
  font-weight: 600;
  color: #B22222;
  white-space: nowrap;
}

.wine-promo-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #B22222;
  color: white;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.wine-timestamps {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 6px;
}

.wine-created,
.wine-updated {
  color: #8B7355;
  font-size: 0.65rem;
  font-style: italic;
}

.add-to-cart-btn {
  margin-top: 12px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(61, 24, 24, 0.3);
}

.add-to-cart-btn:hover {
  background: linear-gradient(135deg, #5D3A3A 0%, #7B4646 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(61, 24, 24, 0.4);
}

.add-to-cart-btn:active {
  transform: translateY(0);
}

.cart-icon {
  width: 20px;
  height: 20px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .wine-specs {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
  
  .wine-price-container {
    align-self: flex-end;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/WineCard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,qDAAqD;EACrD,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAE,kCAAkC;EAChD,aAAa;EACb,sBAAsB;EACtB,sBAAsB,EAAE,sCAAsC;EAC9D,2BAA2B,EAAE,2CAA2C;AAC1E;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,sCAAsC;EACpD,iBAAiB,EAAE,mCAAmC;AACxD;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,uDAAuD;EACrE,mBAAmB,EAAE,qDAAqD;EAC1E,kDAAkD;EAClD,cAAc,EAAE,gCAAgC;AAClD;;AAEA;EACE,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE;IACE,eAAe;IACf,oBAAoB;EACtB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,OAAO,EAAE,yBAAyB;EAClC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,OAAO,EAAE,iDAAiD;EAC1D,qBAAqB,EAAE,qCAAqC;EAC5D,qBAAqB,EAAE,+BAA+B;AACxD;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB,EAAE,2BAA2B;EAC7C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".wine-card {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  position: relative;\n  width: 100%;\n  height: 100%; /* Take full height of grid cell */\n  display: flex;\n  flex-direction: column;\n  will-change: transform; /* Optimize for transform animations */\n  contain: layout style paint; /* CSS containment for better performance */\n}\n\n.wine-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n}\n\n.wine-image-container {\n  position: relative;\n  height: auto; /* Changed from fixed height to auto */\n  overflow: visible; /* Changed from hidden to visible */\n}\n\n.wine-image {\n  width: 100%;\n  height: auto; /* Changed from 100% to auto to maintain aspect ratio */\n  object-fit: contain; /* Changed from cover to contain to show full image */\n  transition: transform 0.3s ease, opacity 0.3s ease;\n  display: block; /* Ensure proper image display */\n}\n\n.wine-image-clickable {\n  cursor: pointer;\n}\n\n/* Disable preview on mobile devices */\n@media (max-width: 768px) {\n  .wine-image-clickable {\n    cursor: default;\n    pointer-events: none;\n  }\n}\n\n.wine-card:hover .wine-image {\n  transform: scale(1.05);\n}\n\n/* Image loading states */\n.wine-image-placeholder {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  opacity: 1;\n}\n\n.wine-image-loading {\n  opacity: 0;\n  position: relative;\n  z-index: 2;\n}\n\n.wine-image-loaded {\n  opacity: 1;\n  position: relative;\n  z-index: 2;\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.wine-type-badge {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  background: rgba(61, 24, 24, 0.9);\n  color: white;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.wine-content {\n  padding: 15px;\n  flex: 1; /* Take remaining space */\n  display: flex;\n  flex-direction: column;\n}\n\n.wine-name {\n  margin: 0 0 6px 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #3D1818;\n  line-height: 1.3;\n  font-family: 'Playfair Display', serif;\n}\n\n.wine-details {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n.wine-region {\n  background: #F7E9D2;\n  color: #3D1818;\n  padding: 3px 6px;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 500;\n}\n\n.wine-vintage {\n  background: #E8D5B7;\n  color: #3D1818;\n  padding: 3px 6px;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 500;\n}\n\n.wine-description {\n  margin: 0 0 12px 0;\n  color: #5D3A3A;\n  line-height: 1.6;\n  font-size: 0.85rem;\n  background: #FAF6E7;\n  padding: 10px;\n  border-radius: 8px;\n  border-left: 3px solid #D4A574;\n  flex: 1; /* Take remaining space to push specs to bottom */\n  white-space: pre-wrap; /* Preserve newlines and whitespace */\n  word-wrap: break-word; /* Break long words if needed */\n}\n\n/* Bullet points in description */\n.wine-description ul {\n  margin: 8px 0;\n  padding-left: 20px;\n  list-style-type: disc;\n}\n\n.wine-description li {\n  margin: 4px 0;\n}\n\n.wine-description p {\n  margin: 8px 0;\n}\n\n.wine-description p:first-child {\n  margin-top: 0;\n}\n\n.wine-description p:last-child {\n  margin-bottom: 0;\n}\n\n.wine-specs {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  margin-top: auto; /* Push to bottom of card */\n  gap: 10px;\n}\n\n.wine-specs-left {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.wine-alcohol {\n  background: #E8D5B7;\n  color: #3D1818;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.wine-temperature {\n  background: #D4E8F5;\n  color: #1B4F72;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.wine-price-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  align-items: flex-end;\n}\n\n.wine-price {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n}\n\n.wine-price-old {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #8B7355;\n  text-decoration: line-through;\n  font-family: 'Playfair Display', serif;\n}\n\n.wine-price-promo {\n  color: #B22222;\n}\n\n.wine-promo-until {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #B22222;\n  white-space: nowrap;\n}\n\n.wine-promo-badge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: #B22222;\n  color: white;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.wine-timestamps {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 6px;\n}\n\n.wine-created,\n.wine-updated {\n  color: #8B7355;\n  font-size: 0.65rem;\n  font-style: italic;\n}\n\n.add-to-cart-btn {\n  margin-top: 12px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  box-shadow: 0 2px 8px rgba(61, 24, 24, 0.3);\n}\n\n.add-to-cart-btn:hover {\n  background: linear-gradient(135deg, #5D3A3A 0%, #7B4646 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(61, 24, 24, 0.4);\n}\n\n.add-to-cart-btn:active {\n  transform: translateY(0);\n}\n\n.cart-icon {\n  width: 20px;\n  height: 20px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .wine-specs {\n    flex-direction: column;\n    gap: 12px;\n    align-items: flex-start;\n  }\n  \n  .wine-price-container {\n    align-self: flex-end;\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
